import React from 'react';
import { Chip } from '@milanote/roma';

import EmojiImage from '../../../components/emoji/EmojiImage';
import ElementReactionPillTooltip from '../../reactions/ElementReactionPillTooltip';
import PressableChip from '../behaviours/PressableChip';
import type { ElementReactionChipDescriptor } from '../elementChipsTypes';
import { ChipBaseProps } from '../../../../common/@roma/src/components/base/chip/ChipBase';

type ReactionChipProps = {
    chip: ElementReactionChipDescriptor;
    currentUserId?: string;
    canModify: boolean;
    /** Pill size. Defaults to 'xs' to match ElementChipsContainer / TaskItemChipsContainer defaults. */
    size?: ChipBaseProps['size'];
    /** Toggles the current user's reaction for this emoji. */
    onPress: () => void;
};

/**
 * Renders a reaction pill for the generic element pills path.
 */
const ReactionChip: React.FC<ReactionChipProps> = ({
    chip,
    currentUserId = '',
    canModify,
    size = 'sm',
    onPress,
}) => {
    const { emojiCode, userIds, isSearchHighlighted } = chip;

    return (
        <PressableChip canPress={canModify} onPress={onPress}>
            <ElementReactionPillTooltip emojiCode={emojiCode} currentUserId={currentUserId} userIds={userIds}>
                <Chip
                    variant={userIds.includes(currentUserId) ? 'user' : 'normal'}
                    count={userIds.length}
                    size={size}
                    isDisabled={!canModify}
                    isSearchHighlighted={isSearchHighlighted}
                    // Reduce default chip padding for reactions
                    className="px-0.75"
                >
                    <EmojiImage emojiCode={emojiCode} className={size === 'xs' ? 'size-3' : 'size-3.5'} />
                </Chip>
            </ElementReactionPillTooltip>
        </PressableChip>
    );
};

export default ReactionChip;
